import { render, staticRenderFns } from "./ProgramDetailEpisodes.vue?vue&type=template&id=1efa59f0&scoped=true&"
import script from "./ProgramDetailEpisodes.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailEpisodes.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailEpisodes.vue?vue&type=style&index=0&id=1efa59f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa59f0",
  null
  
)

export default component.exports